import { IRegion } from '../../../types/geoSwitcher';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

import { TGetPopularCitiesSucceed, EGetPopularCitiesActionTypes } from './types';

export const getPopularCitiesSucceed: (popularCities: IRegion[]) => TGetPopularCitiesSucceed = actionGenerator<
  EGetPopularCitiesActionTypes.Succeed,
  IRegion[]
>(EGetPopularCitiesActionTypes.Succeed);
